export default __webpack_public_path__ + "static/footerlogo-30f6d4048304539daa6a3ecf4766d1d1.png";